import actions from './actions';
import initialState from '../initialState';

export const loanReducer = (state = initialState.loan, action) => {
    switch (action.type) {
        case actions.EDIT_STD_LOAN_MODAL:
            return {
                ...state,
                editStdLoanModal: action.state.editStdLoanModal,
            };
        case actions.EDIT_MASTER_NOTE_MODAL:
            return {
                ...state,
                editMasterNoteModal: action.state.editMasterNoteModal,
            };
        case actions.REPAYMENT_MODAL:
            return { ...state, repaymentModal: action.state.repaymentModal };
        case actions.DELETE_LOAN_MODAL:
            return { ...state, deleteLoanModal: action.state.deleteLoanModal };
        case actions.EDIT_BORROWER_MODAL:
            return {
                ...state,
                borrowerEditModal: action.state.borrowerEditModal,
            };
        case actions.LOAN_ACTION_MODAL:
            return { ...state, loanActionModal: action.state.loanActionModal };
        case actions.CANCEL_INSURANCE_MODAL:
            return {
                ...state,
                cancelInsuranceModal: action.state.cancelInsuranceModal,
            };
        case actions.LOSE_LOAN_MODAL:
            return { ...state, loseLoanModal: action.state.loseLoanModal };
        case actions.EXTENSION_MODAL:
            return { ...state, extensionModal: action.state.extensionModal };
        case actions.HOLDBACK_RELEASE_MODAL:
            return {
                ...state,
                holdbackReleaseModal: action.state.holdbackReleaseModal,
            };
        case actions.RENTAL_DSCR_MODAL:
            return { ...state, rentalDscrModal: action.state.rentalDscrModal };
        case actions.BUILDRENT_CONVERSION_MODAL:
            return {
                ...state,
                buildRentConversionModal: action.state.buildRentConversionModal,
            };
        case actions.LINK_LOAN_WITH_BCLIENT_MODAL:
            return {
                ...state,
                linkLoanWithBClientModal: action.state.linkLoanWithBClientModal,
            };
        case actions.REVERT_TO_APPROVED_MODAL:
            return {
                ...state,
                revertToApprovedModal: action.state.revertToApprovedModal,
            };
        case actions.RESTORE_LOAN_MODAL:
            return {
                ...state,
                restoreLoanModal: action.state.restoreLoanModal,
            };
        case actions.PROPERTY_INSURANCE_MODAL:
            return {
                ...state,
                propertyInsuranceModal: action.state.propertyInsuranceModal,
            };
        case actions.CHANGE_LOAN_LOANTYPE_MODAL:
            return {
                ...state,
                changeLoanTypeModal: action.state.changeLoanTypeModal,
            };
        case actions.LOAN_REPAYMENT_MODAL:
            return { ...state, repaymentModal: action.state.repaymentModal };
        case actions.LOAN_SUMMARY_MODAL:
            return {
                ...state,
                loanSummaryModal: action.state.loanSummaryModal,
            };
        case actions.TERMINATE_MASTERNOTE_MODAL:
            return {
                ...state,
                terminateMasterNoteModal: action.state.terminateMasterNoteModal,
            };
        case actions.AUDIT_HISTORY_MODAL:
            return {
                ...state,
                auditHistoryModal: action.state.auditHistoryModal,
            };
        default:
            return { ...state };
    }
};

export default loanReducer;
